import { useLayoutEffect, useRef } from 'react';

/**
 * Возвращает ref для контейнера портального меню и сообщает о его фактической высоте.
 *
 * @param onHeightChange - Колбэк, вызываемый при изменении высоты меню.
 * @returns Ref, который нужно повесить на контейнер портального меню.
 */
export const usePortalMenuHeight = (
  onHeightChange?: (height: number) => void,
) => {
  const menuRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const menuElement = menuRef.current;

    if (!menuElement || !onHeightChange) {
      return;
    }

    const reportHeight = () => {
      const height = Math.round(menuElement.getBoundingClientRect().height);

      if (height > 0) {
        onHeightChange(height);
      }
    };

    const observer = new ResizeObserver(reportHeight);

    observer.observe(menuElement);
    reportHeight();

    return () => observer.disconnect();
  }, [onHeightChange]);

  return menuRef;
};
